var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_175_35707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3652 42L22.4579 27.9H15.0058C14.6315 27.9 14.3593 27.7333 14.1891 27.4C14.019 27.0667 14.019 26.75 14.1891 26.45L26.6943 6H28.787L26.6943 20.05H34.0443C34.4186 20.05 34.6994 20.2167 34.8865 20.55C35.0737 20.8833 35.0822 21.2 34.912 21.5L22.4579 42H20.3652Z",
    fill: "#0BAB47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_175_35707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.9ac3c912a02ddc1d29abf9de3f6caa7e.svg";
export { ForwardRef as ReactComponent };